import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import musicFile from '../../asset/music/spring.mp3'
import CallInfo from '../../component/CallInfo';
import AccountList from '../../component/Account/AccountList';



const JeongYuJin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "조현근 ♡︎ 정유진 결혼합니다.";
    const openDesc = "25년 8월 31일 오후 12시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/277/thumb.jpg";

    const placeTelNum = "031-487-8100";

    const lng = 126.827921256137;
    const lat = 37.3149306266479 ;

    const forParking = "건물 내 주차 불가하여 건너편 연계 주차장 이용 \n바랍니다.\n- 화랑주차타워 (단원구 광덕서로 106)\n- 월드타워주차장 (단원구 광덕3로 135-18)\n- 고잔역 환승 공영주차장 (단원구 광덕로4로 103)";
    const forBus = "고잔역 뒤 정류장 하차 \n97, 98, 99-1, 500번 버스";
    const forSubway = "수인분당선, 4호선 고잔역(고대안산병원) 2번 \n출구에서 왼쪽 대로변 따라 200m 전방에 위치";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "모시는 글";

    const msg1 = "두 사람이 함께 맞이하는 세번째 여름,\n평생의 연을 맺고자 합니다.";
    const msg2 = "푸른 녹음 진 여름처럼\n밝고 행복하게 살겠습니다."
    const msg3 = "새로운 시작을 귀한 걸음 하시어\n축복해주시면 감사하겠습니다."


    const parents = [
        {groom : "임종수 · 이효희의 아들"},
        {bride : "박대식 · 채윤경의 딸"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "조현근",
            bank: "카카오뱅크",
            accountNumber : "3333-06-6940799",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "조영구",
            bank: "기업은행",
            accountNumber : "031-494-7722",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "구영란",
            bank: "국민은행",
            accountNumber : "595125-96-12101",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "정유진",
            bank: "카카오뱅크",
            accountNumber : "3333-04-6213664",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "정양민",
            bank: "기업은행",
            accountNumber : "123-148897-01-011",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "김동화",
            bank: "기업은행",
            accountNumber : "010-5009-6940",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 가지지 않으셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "완전 생생해!",
            brideAnswer: "잊을 수 없는 날"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "만감이 교차!",
            brideAnswer: "나도 그래!"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "평생 사랑해!",
            brideAnswer: "이제 내꺼다!"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "젤 잘해줄게!",
            brideAnswer: "내가 더!"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복히 살자!",
            brideAnswer: "잘 살아보장"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "조현근",
            call: "010 7167 1306"
        },
        {
            role: "신랑 부",
            name: "조영구",
            call: "010 6390 9154"
        }
        ,{
            role: "신랑 모",
            name: "구영란",
            call: "010 6736 1218"
        }
    ]
    


    const brideCallInfoList = [
        {
            role: "신부",
            name: "정유진",
            call: "010 3939 6940"
        },
        {
            role: "신부 부",
            name: "정양민",
            call: "010 9067 4808"
        }
        ,{
            role: "신부 모",
            name: "김동화",
            call: "010 5009 6940"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicFile}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#505D89"} letteringFontColor={"#F4E0CD"} dateColor={"#505D89"} bottom={"22%"} bottom2={"13.5%"} dateBottom={"82%"} top={"5%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter titleFontSize={"20px"} fontSize={"15px"}  title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontSize={"15px"}  fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList fontSize={"13px"} titleFontSize={"15px"}  conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc fontSize={"13px"} titleFontSize={"15px"} isPoint={true} forParking={forParking} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default JeongYuJin;